import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import {
    KitchenHomeApplianceOptionId, KitchenLayoutId, KitchenStyleId, KitchenShadeSelectorId,
} from '@core/constants/Shape';
import PropertyOptionId from '@core/constants/PropertyOption';
import OwnerTenantOptionId from '@core/constants/OwnerTenantOption';
import {
    ApplianceLevelOptionId, BudgetOptionId,
} from '@core/constants/Option';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';

const kitchenForm: IForm = {
    formId       : PublishedFormId.KitchenDesign,
    type         : FormTypeId.Kitchen,
    thumbnailURL : '/resized-images/forms/kitchen.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.KitchenStyle,
        IFormFieldKey.KitchenLayout,
        IFormFieldKey.UploadFiles,
        IFormFieldKey.KitchenMaterialShade,
        IFormFieldKey.KitchenHomeAppliance,
        IFormFieldKey.ApplianceLevel,
        IFormFieldKey.Budget,
        IFormFieldKey.ProjectInformation,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        uploadFiles: {
            value    : undefined,
            required : false,
        },
        kitchenLayout: {
            value   : undefined,
            options : [
                KitchenLayoutId.LayoutStraight,
                KitchenLayoutId.LayoutL,
                KitchenLayoutId.LayoutIsland,
                KitchenLayoutId.LayoutParallel,
                KitchenLayoutId.LayoutU,
            ],
            required: true,
        },
        kitchenStyle: {
            value   : undefined,
            options : [
                KitchenStyleId.KitchenArtDeco,
                KitchenStyleId.KitchenFullBlack,
                KitchenStyleId.KitchenNatural,
                KitchenStyleId.KitchenIndustrialLoft,
                KitchenStyleId.KitchenJapandi,
                KitchenStyleId.KitchenTraditional,
                KitchenStyleId.KitchenPastel,
                KitchenStyleId.KitchenRural,
                KitchenStyleId.KitchenModern,
                KitchenStyleId.KitchenRusticChic,
                KitchenStyleId.KitchenRusticModern,
                KitchenStyleId.KitchenMinimalist,
                KitchenStyleId.KitchenStrikingMarble,
                KitchenStyleId.KitchenTerracotta,
                KitchenStyleId.KitchenTerrazzo,
                KitchenStyleId.KitchenVegetated,
                KitchenStyleId.KitchenIndustrial,
                KitchenStyleId.KitchenScandinavian,
            ],
            required   : true,
            withFilter : true,
        },
        kitchenMaterialShade: {
            value   : undefined,
            options : [
                KitchenShadeSelectorId.ShadeTexture,
                KitchenShadeSelectorId.ShadePattern,
                KitchenShadeSelectorId.ShadeWoodEffect,
                KitchenShadeSelectorId.ShadeStoneEffect,
                KitchenShadeSelectorId.ShadeConcreteEffect,
                KitchenShadeSelectorId.ShadeMarbleEffect,
                KitchenShadeSelectorId.ShadeUltraMattEffect,
                KitchenShadeSelectorId.ShadeGraniteEffect,
                KitchenShadeSelectorId.ShadeQuartzEffect,
                KitchenShadeSelectorId.ShadeCeramicEffect,
                KitchenShadeSelectorId.ShadeTerrazzoEffect,
            ],
            required: true,
        },
        kitchenHomeAppliance: {
            [KitchenHomeApplianceOptionId.KitchenBakingTray]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.kitchenCook]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenOven]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenMicroWave]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenHood]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenDishwasher]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenFridge]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.KitchenSink]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
            [KitchenHomeApplianceOptionId.kitchenWineCellar]: {
                value : undefined,
                min   : 0,
                max   : 1,
            },
        },
        applianceLevel: {
            value   : undefined,
            options : [
                ApplianceLevelOptionId.Eco,
                ApplianceLevelOptionId.Premium,
                ApplianceLevelOptionId.Luxe,
            ],
            required: true,
        },
        budget: {
            value   : undefined,
            options : [
                BudgetOptionId.Eco,
                BudgetOptionId.Premium,
                BudgetOptionId.High,
                BudgetOptionId.Luxe,
            ],
            required: true,
        },
        projectInformation: {
            laying: {
                value: undefined,
            },
            accompaniment: {
                value: undefined,
            },
            property: {
                value   : undefined,
                options : [
                    PropertyOptionId.House,
                    PropertyOptionId.Flat,
                ],
                required: true,
            },
            ownerTenant: {
                value   : undefined,
                options : [
                    OwnerTenantOptionId.Owner,
                    OwnerTenantOptionId.Tenant,
                ],
                required: true,
            },
        },
        additionalData: additionalDataFactory({
            hasQuantity : false,
            hasBudget   : false,
            hasUpload   : false,
        }),
        contact: fieldsContact,
    },
};

export default kitchenForm;
